export default "__VITE_ASSET__CEWHwY$K__"